import { Alert } from '@mui/material';
import React from 'react';
import { UtilityPortalCredentialSection } from './index';
import { PendingCredentialFields } from './PendingCredentialFields';
import { UnsupportedProviderNotice } from './UnsupportedProviderNotice';

/**
 * What a saved utility shows for each outcome of its credential lookup.
 *
 * 'loading' renders nothing rather than an empty form, because "we have not asked yet" and "there
 * is no credential" look identical once the answer is null.
 */
const renderSavedState = (credentialState, props) => {
  if (credentialState === 'loading') return null;
  if (credentialState === 'unavailable') {
    return /*#__PURE__*/React.createElement(Alert, {
      severity: "warning",
      sx: {
        marginTop: '16px'
      }
    }, "Bill automation credentials could not be loaded, so this utility's credential state is unknown. Reload before adding or changing one.");
  }
  return /*#__PURE__*/React.createElement(UtilityPortalCredentialSection, props);
};

/**
 * The credential block, wherever a billing template is edited.
 *
 * Three modals render this. Keeping the staff gate in one place is the point: a fourth call site
 * that forgot it would offer the form to a customer.
 *
 * `propertyUtilityId` decides the mode. Present means a saved utility that can own a credential
 * now; absent means the utility does not exist yet, so the fields are collected and saved after
 * creation.
 */
export const UtilityCredentialSlot = _ref => {
  let isLivableStaff = _ref.isLivableStaff,
    isScraperSupportedProvider = _ref.isScraperSupportedProvider,
    className = _ref.className,
    companyId = _ref.companyId,
    propertyId = _ref.propertyId,
    propertyUtilityId = _ref.propertyUtilityId,
    utilityProviderId = _ref.utilityProviderId,
    utilityTypeId = _ref.utilityTypeId,
    providerName = _ref.providerName,
    credential = _ref.credential,
    _ref$credentialState = _ref.credentialState,
    credentialState = _ref$credentialState === void 0 ? 'loading' : _ref$credentialState,
    onChanged = _ref.onChanged,
    pendingRef = _ref.pendingRef;
  if (!isLivableStaff) return null;
  if (!isScraperSupportedProvider) {
    return /*#__PURE__*/React.createElement("div", {
      className: className
    }, /*#__PURE__*/React.createElement(UnsupportedProviderNotice, {
      providerName: providerName
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, propertyUtilityId ?
  // Only a lookup that came back decides what is shown. Both other states arrive here as
  // credential=null, which is indistinguishable from "none saved" and offers the capture
  // form; an operator typing into that form is rotating a credential that may exist. So
  // render nothing while the answer is outstanding, and say so when it never came.
  renderSavedState(credentialState, {
    companyId,
    utilityProviderId,
    propertyId,
    propertyUtilityId,
    utilityTypeId,
    credential,
    onChanged
  }) : /*#__PURE__*/React.createElement(PendingCredentialFields, {
    dataRef: pendingRef,
    providerName: providerName
  }));
};